import { axiosPlacement } from "./AxiosInstance";

const API_URL_APPLICATION = "/jobappliedstudents";

// Service function for posting job application data
export const submitJobApplicationData = async (applicationData, jobId) => {
  try {
    const formData = new FormData();

    if (!jobId) {
      console.error("Service: No jobId provided");
      throw new Error("Job ID is required for application submission");
    }

    Object.keys(applicationData).forEach((key) => {
      if (key !== "cvUpload" && applicationData[key] !== undefined && applicationData[key] !== null) {
        if (Array.isArray(applicationData[key])) {
          // Join array elements with commas to match the backend's expected String format
          formData.append(key, applicationData[key].join(","));
        } else {
          formData.append(key, applicationData[key]);
        }
      }
    });

    // Append CV file
    if (applicationData.cvUpload) {
      formData.append("cvUpload", applicationData.cvUpload);
    }

    const response = await axiosPlacement.post(API_URL_APPLICATION, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error submitting job application data:", error);
    throw error;
  }
};

// Service function for getting job applied notifications
export const getJobAppliedNotifications = async () => {
  try {
    const response = await axiosPlacement.get("/jobappliednotifications");
    return response.data;
  } catch (error) {
    console.error("Error fetching job applied notifications:", error);
    throw error;
  }
};

